<script>
  import moment from 'moment';
  import conciliacaoProjetoServico from '../servico';
  import { abrirBlob, dicaAbrir } from '~js/abrir-arquivo';

  const POR_PAGINA = 10;
  const BASE_OLE = moment.utc('1899-12-30', 'YYYY-MM-DD');
  const DIAS_SEMANA = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

  const SITUACOES = {
    'processado': { rotulo: 'Processado', cls: 'ok', icon: 'fa-check-circle' },
    'aguardando': { rotulo: 'Aguardando o Isaac', cls: 'esp', icon: 'fa-clock-o' },
    'falhou': { rotulo: 'Não virou lançamento', cls: 'erro', icon: 'fa-exclamation-triangle' },
    'nao-enviado': { rotulo: 'Ainda não enviado', cls: 'novo', icon: 'fa-inbox' },
  };

  export default {
    props: {
      idConta: { type: Number, default: 0 },
      nomeConta: { type: String, default: '' },
      dataIni: { type: Date, default: null },
      dataFim: { type: Date, default: null },
    },
    data() {
      return {
        carregando: false,
        erro: '',
        dados: null,
        escopo: 'periodo',
        busca: '',
        limite: POR_PAGINA,
        abrindo: '',
      };
    },
    computed: {
      dicaAbrir,
      arquivos() {
        const lista = ((this.dados && this.dados.arquivos) || []).map(a => Object.assign({}, a, this.movimento(a)));
        return lista.sort((x, y) => (y.movFim - x.movFim) || (this.instante(y.dataReferencia) - this.instante(x.dataReferencia)));
      },
      temPeriodo() { return !!this.dataIni && !!this.dataFim; },
      periodoOle() {
        if (!this.temPeriodo) return null;
        return { ini: this.paraOle(this.dataIni), fim: this.paraOle(this.dataFim) };
      },
      periodoTexto() {
        if (!this.temPeriodo) return '';
        const ini = moment(this.dataIni).format('DD/MM/YYYY');
        const fim = moment(this.dataFim).format('DD/MM/YYYY');
        return ini === fim ? ini : ini + ' a ' + fim;
      },
      doPeriodo() {
        if (!this.periodoOle) return [];
        const p = this.periodoOle;
        return this.arquivos.filter(a => a.movIni > 0 ? (a.movIni <= p.fim && a.movFim >= p.ini) : a.situacao !== 'processado');
      },
      base() { return this.escopo === 'periodo' && this.temPeriodo ? this.doPeriodo : this.arquivos; },
      filtrados() {
        const termo = (this.busca || '').trim().toLowerCase();
        if (!termo) return this.base;
        return this.base.filter(a => (a.nome || '').toLowerCase().indexOf(termo) >= 0);
      },
      visiveis() { return this.filtrados.slice(0, this.limite); },
      restantes() { return Math.max(0, this.filtrados.length - this.limite); },
      grupos() {
        const grupos = [];
        this.visiveis.forEach(a => {
          const chave = a.movFim > 0 ? a.movFim : 'sem-data';
          let grupo = grupos.length ? grupos[grupos.length - 1] : null;
          if (!grupo || grupo.chave !== chave) {
            grupo = { chave, titulo: a.movFim > 0 ? this.tituloDia(this.deOle(a.movFim)) : 'Sem data de movimento', itens: [] };
            grupos.push(grupo);
          }
          grupo.itens.push(a);
        });
        return grupos;
      },
      ultimoRecebido() {
        const ultimo = this.arquivos.reduce((maior, a) => this.instante(a.dataReferencia) > this.instante(maior) ? a.dataReferencia : maior, null);
        return ultimo ? moment(ultimo).format('DD/MM/YYYY [às] HH:mm') : '';
      },
      qtdNaoEnviados() { return this.arquivos.filter(a => a.situacao === 'nao-enviado').length; },
    },
    watch: {
      escopo() { this.limite = POR_PAGINA; },
      busca() { this.limite = POR_PAGINA; },
    },
    mounted() {
      this.carregar();
    },
    methods: {
      carregar() {
        if (!(this.idConta > 0)) {
          this.erro = 'Conta não identificada.';
          return;
        }

        this.carregando = true;
        this.erro = '';
        conciliacaoProjetoServico.extratosConta(this.idConta)
          .then(dados => {
            this.carregando = false;
            this.dados = dados || { arquivos: [] };
            this.escopo = this.temPeriodo && this.doPeriodo.length ? 'periodo' : 'todos';
            this.limite = POR_PAGINA;
          })
          .catch(res => {
            this.carregando = false;
            this.erro = (res && res.body && res.body.message) || 'Não foi possível listar os extratos da conta.';
          });
      },
      paraOle(data) { return moment.utc(moment(data).format('YYYY-MM-DD'), 'YYYY-MM-DD').diff(BASE_OLE, 'days'); },
      deOle(n) { return moment(BASE_OLE.clone().add(n, 'days').format('YYYY-MM-DD'), 'YYYY-MM-DD').toDate(); },
      instante(data) { return data ? moment(data).valueOf() : 0; },
      movimento(a) {
        if (a.dataIni > 0) return { movIni: a.dataIni, movFim: a.dataFim || a.dataIni, movPelaPasta: false };
        const partes = (a.nome || '').split('/');
        const pasta = partes.length > 1 ? partes[partes.length - 2] : '';
        const dia = /^\d{2}-\d{2}-\d{2}$/.test(pasta) ? moment(pasta, 'DD-MM-YY', true) : null;
        if (!dia || !dia.isValid()) return { movIni: 0, movFim: 0, movPelaPasta: false };
        const ole = this.paraOle(dia.toDate());
        return { movIni: ole, movFim: ole, movPelaPasta: true };
      },
      tituloDia(data) {
        const dia = moment(data).startOf('day');
        const hoje = moment().startOf('day');
        if (dia.isSame(hoje)) return 'Hoje · ' + dia.format('DD/MM/YYYY');
        if (dia.isSame(hoje.clone().subtract(1, 'day'))) return 'Ontem · ' + dia.format('DD/MM/YYYY');
        return DIAS_SEMANA[dia.day()] + ' · ' + dia.format('DD/MM/YYYY');
      },
      hora(data) { return data ? moment(data).format('HH:mm') : ''; },
      situacao(a) { return SITUACOES[a.situacao] || SITUACOES['nao-enviado']; },
      periodoArquivo(a) {
        if (!(a.movIni > 0)) return '';
        const ini = moment(this.deOle(a.movIni));
        const fim = moment(this.deOle(a.movFim));
        return a.movIni === a.movFim ? ini.format('DD/MM/YYYY') : ini.format('DD/MM') + ' a ' + fim.format('DD/MM/YYYY');
      },
      noPeriodo(a) {
        const p = this.periodoOle;
        return !!p && a.movIni > 0 && a.movIni <= p.fim && a.movFim >= p.ini;
      },
      nomeCurto(nome) { return (nome || '').split('/').pop(); },
      pasta(nome) {
        const partes = (nome || '').split('/');
        return partes.length > 1 ? partes.slice(0, -1).join('/') : '';
      },
      mostrarMais() { this.limite += POR_PAGINA; },
      visualizar(a) {
        if (this.abrindo) return;
        this.abrindo = a.nome;
        conciliacaoProjetoServico.arquivoOrigemAnexo('extrato-conta', this.idConta, a.nome)
          .then(blob => {
            this.abrindo = '';
            abrirBlob(blob, this.nomeCurto(a.nome));
          })
          .catch(() => {
            this.abrindo = '';
            toastr.error('Não foi possível abrir o arquivo ' + this.nomeCurto(a.nome) + '.');
          });
      },
    },
  };
</script>

<template>
  <div class="exc-ov">
    <div class="exc-modal" role="dialog" aria-modal="true" aria-label="Extratos da conta">
      <div class="exc-head">
        <div class="exc-head-ic"><i class="fa fa-file-pdf-o"></i></div>
        <div class="exc-head-txt">
          <h4>Extratos da conta</h4>
          <small>{{ (dados && dados.nomeConta) || nomeConta }}</small>
        </div>
        <div v-if="dados && arquivos.length" class="exc-head-resumo">
          <div><b>{{ arquivos.length }}</b> arquivo{{ arquivos.length > 1 ? 's' : '' }}</div>
          <small v-if="ultimoRecebido">último em {{ ultimoRecebido }}</small>
        </div>
      </div>

      <div v-if="dados && arquivos.length" class="exc-barra">
        <div v-if="temPeriodo" class="exc-seg">
          <button type="button" :class="{ ativo: escopo === 'periodo' }" @click="escopo = 'periodo'">
            <i class="fa fa-calendar"></i> Do período {{ periodoTexto }} <span class="exc-n">{{ doPeriodo.length }}</span>
          </button>
          <button type="button" :class="{ ativo: escopo === 'todos' }" @click="escopo = 'todos'">
            <i class="fa fa-folder-open-o"></i> Todos da conta <span class="exc-n">{{ arquivos.length }}</span>
          </button>
        </div>
        <div class="exc-busca">
          <i class="fa fa-search"></i>
          <input v-model="busca" maxlength="60" placeholder="Nome do arquivo (ex.: 28092026)">
        </div>
      </div>

      <div class="exc-corpo">
        <div v-if="carregando" class="exc-msg"><i class="fa fa-spinner fa-pulse"></i> Buscando os extratos da conta...</div>
        <div v-else-if="erro" class="exc-msg exc-erro"><i class="fa fa-exclamation-circle"></i> {{ erro }}</div>
        <div v-else-if="!arquivos.length" class="exc-vazio">
          <i class="fa fa-file-pdf-o"></i>
          <b>Nenhum extrato encontrado para esta conta</b>
          <span>Os extratos são enviados pela Lista de Conciliação de Banco.</span>
        </div>
        <div v-else-if="!filtrados.length" class="exc-vazio">
          <i class="fa fa-search"></i>
          <b>{{ busca.trim() ? 'Nenhum arquivo com esse nome' : 'Nenhum extrato cobre o período ' + periodoTexto }}</b>
          <button v-if="escopo === 'periodo'" type="button" class="exc-link" @click="escopo = 'todos'">Ver todos os {{ arquivos.length }} da conta</button>
        </div>
        <template v-else>
          <div v-for="g in grupos" :key="g.chave" class="exc-grupo">
            <div class="exc-dia"><span>{{ g.titulo }}</span></div>
            <div v-for="a in g.itens" :key="a.nome" class="exc-item" :class="'exc-' + situacao(a).cls">
              <div class="exc-hora mono">{{ hora(a.dataReferencia) || '—' }}</div>
              <div class="exc-pdf">PDF</div>
              <div class="exc-info">
                <div class="exc-nome" :title="a.nome">
                  {{ nomeCurto(a.nome) }}
                  <small v-if="pasta(a.nome)">{{ pasta(a.nome) }}</small>
                </div>
                <div class="exc-meta">
                  <span class="exc-sit" :class="'exc-sit-' + situacao(a).cls"><i class="fa" :class="situacao(a).icon"></i> {{ situacao(a).rotulo }}</span>
                  <span v-if="periodoArquivo(a)" class="exc-chip" :class="{ 'exc-chip-per': noPeriodo(a) }" :title="a.movPelaPasta ? 'Data tirada da pasta do arquivo: nenhuma linha do extrato ficou registrada com o nome dele' : ''"><i class="fa fa-calendar-o"></i> Movimento {{ periodoArquivo(a) }}</span>
                  <span v-if="a.consolidado" class="exc-chip" title="Arquivo da pasta Contas, processado para esta e outras contas"><i class="fa fa-folder-open-o"></i> Pasta Contas</span>
                  <span v-if="a.qtdeLinhas > 0" class="exc-chip"><i class="fa fa-list"></i> {{ a.qtdeLinhas }} linha{{ a.qtdeLinhas > 1 ? 's' : '' }}</span>
                  <span v-if="a.dataEnvio" class="exc-dt">Enviado {{ a.dataEnvio }}</span>
                  <span v-if="a.dataProcessamento" class="exc-dt">Processado {{ a.dataProcessamento }}</span>
                </div>
                <div v-if="a.situacao === 'falhou' && a.detalhe" class="exc-detalhe"><i class="fa fa-info-circle"></i> {{ a.detalhe }}</div>
              </div>
              <button type="button" class="exc-ver" :disabled="!!abrindo" @click="visualizar(a)">
                <i class="fa" :class="abrindo === a.nome ? 'fa-spinner fa-pulse' : 'fa-eye'"></i> Visualizar
              </button>
            </div>
          </div>

          <button v-if="restantes > 0" type="button" class="exc-mais" @click="mostrarMais">
            <i class="fa fa-chevron-down"></i> Mostrar mais {{ Math.min(restantes, 10) }}
            <small>({{ restantes }} restante{{ restantes > 1 ? 's' : '' }})</small>
          </button>
        </template>
      </div>

      <div class="exc-foot">
        <div class="exc-foot-info">
          <template v-if="dados && filtrados.length">Mostrando {{ visiveis.length }} de {{ filtrados.length }}</template>
          <template v-if="qtdNaoEnviados"> · {{ qtdNaoEnviados }} ainda não enviado{{ qtdNaoEnviados > 1 ? 's' : '' }}</template>
        </div>
        <button type="button" class="exc-sair" @click="$emit('fechar')"><i class="fa fa-sign-out"></i> Sair</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .exc-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.45); z-index: 2100; display: flex; align-items: center; justify-content: center; padding: 16px; }
  .exc-modal { width: 860px; max-width: 97vw; max-height: 90vh; display: flex; flex-direction: column; background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.28); overflow: hidden; }
  .exc-head { flex: 0 0 auto; display: flex; align-items: center; gap: 14px; padding: 15px 20px; background: #f7f9fa; border-bottom: 1px solid #e6e9ed; color: #1c2024; }
  .exc-head-ic { flex: none; width: 38px; height: 38px; border-radius: 8px; background: #e8f0fa; color: #2b6cb0; display: flex; align-items: center; justify-content: center; font-size: 18px; }
  .exc-head-txt { flex: 1 1 auto; min-width: 0; }
  .exc-head-txt h4 { margin: 0; font-size: 16px; font-weight: 600; color: #1c2024; }
  .exc-head-txt small { display: block; margin-top: 2px; font-size: 12px; color: #6b747e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .exc-head-resumo { flex: none; text-align: right; font-size: 13px; color: #4b545e; }
  .exc-head-resumo b { font-size: 18px; color: #1c2024; }
  .exc-head-resumo small { display: block; font-size: 11.5px; color: #8a939c; }

  .exc-barra { flex: 0 0 auto; display: flex; flex-wrap: wrap; gap: 10px; align-items: center; padding: 12px 20px; border-bottom: 1px solid #e6eaee; background: #fff; }
  .exc-seg { display: flex; border: 1px solid #c9d6e6; border-radius: 7px; overflow: hidden; background: #fff; }
  .exc-seg button { height: 32px; padding: 0 12px; border: none; background: #fff; color: #4b545e; font-size: 12.5px; font-weight: 600; white-space: nowrap; }
  .exc-seg button + button { border-left: 1px solid #c9d6e6; }
  .exc-seg button .fa { margin-right: 4px; color: #8a9bb0; }
  .exc-seg button.ativo { background: #e8f0fa; color: #1e4f86; }
  .exc-seg button.ativo .fa { color: #2b6cb0; }
  .exc-n { display: inline-block; min-width: 20px; margin-left: 4px; padding: 0 6px; border-radius: 9px; background: #eef1f4; color: #5b6570; font-size: 11px; text-align: center; }
  .exc-seg button.ativo .exc-n { background: #2b6cb0; color: #fff; }
  .exc-busca { flex: 1 1 200px; min-width: 0; position: relative; }
  .exc-busca .fa { position: absolute; left: 10px; top: 9px; color: #9aa3ac; font-size: 13px; }
  .exc-busca input { width: 100%; height: 32px; padding: 0 10px 0 30px; border: 1px solid #d3d8de; border-radius: 7px; font-size: 12.5px; outline: none; }
  .exc-busca input:focus { border-color: #2b6cb0; box-shadow: 0 0 0 2px rgba(43,108,176,.15); }

  .exc-corpo { flex: 1 1 auto; min-height: 220px; overflow: auto; padding: 6px 20px 16px; }
  .exc-msg { padding: 40px 10px; text-align: center; color: #8a939c; font-size: 13px; }
  .exc-erro { color: #a13c3c; }
  .exc-vazio { display: flex; flex-direction: column; align-items: center; gap: 6px; padding: 44px 16px; text-align: center; color: #6b747e; font-size: 12.5px; }
  .exc-vazio > .fa { font-size: 30px; color: #b9c8da; }
  .exc-vazio > b { font-size: 14px; color: #3b444d; }
  .exc-link { border: none; background: transparent; color: #2b6cb0; font-weight: 600; font-size: 12.5px; padding: 4px; }
  .exc-link:hover { text-decoration: underline; }

  .exc-grupo { position: relative; }
  .exc-dia { position: sticky; top: 0; z-index: 1; padding: 12px 0 6px; background: #fff; }
  .exc-dia span { display: inline-block; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .05em; color: #2b6cb0; background: #e8f0fa; border-radius: 10px; padding: 3px 10px; }
  .exc-item { display: flex; align-items: center; gap: 12px; padding: 10px 12px; margin-bottom: 7px; border: 1px solid #e3e8ee; border-left: 3px solid #2b6cb0; border-radius: 7px; background: #fff; transition: box-shadow .15s, border-color .15s; }
  .exc-item:hover { border-color: #b8cce4; box-shadow: 0 3px 12px rgba(30,79,134,.08); }
  .exc-item.exc-esp { border-left-color: #d69e2e; }
  .exc-item.exc-erro { border-left-color: #c0392b; background: #fffaf8; }
  .exc-item.exc-novo { border-left-color: #9aa3ac; }
  .exc-hora { flex: none; width: 40px; font-size: 12px; color: #6b747e; text-align: center; }
  .exc-pdf { flex: none; font-size: 9px; font-weight: 700; letter-spacing: .3px; color: #c0392b; background: #fdecec; border: 1px solid #f5c6c6; border-radius: 4px; padding: 3px 5px; }
  .exc-info { flex: 1 1 auto; min-width: 0; }
  .exc-nome { font-size: 13px; font-weight: 600; color: #1c2024; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .exc-nome small { color: #9aa3ac; font-weight: normal; margin-left: 6px; font-size: 11px; }
  .exc-meta { display: flex; flex-wrap: wrap; align-items: center; gap: 5px 10px; margin-top: 4px; font-size: 11.5px; color: #6b747e; }
  .exc-sit { font-weight: 600; }
  .exc-sit-ok { color: #0a6d4d; }
  .exc-sit-esp { color: #a06b00; }
  .exc-sit-erro { color: #a13c3c; }
  .exc-sit-novo { color: #5b6570; }
  .exc-chip { padding: 1px 8px; border-radius: 9px; background: #eef1f4; color: #4b545e; }
  .exc-chip .fa { margin-right: 3px; color: #8a939c; }
  .exc-chip-per { background: #e8f0fa; color: #1e4f86; font-weight: 600; }
  .exc-chip-per .fa { color: #2b6cb0; }
  .exc-dt { color: #8a939c; }
  .exc-detalhe { margin-top: 4px; font-size: 11.5px; color: #a13c3c; }
  .exc-ver { flex: none; display: inline-flex; align-items: center; gap: 6px; height: 30px; padding: 0 12px; border: 1px solid #c9d6e6; border-radius: 6px; background: #fff; color: #2b6cb0; font-size: 12px; font-weight: 600; }
  .exc-ver:hover:not(:disabled) { background: #e8f0fa; border-color: #2b6cb0; }
  .exc-ver:disabled { opacity: .65; }
  .exc-mais { display: flex; align-items: center; justify-content: center; gap: 6px; width: 100%; margin-top: 6px; padding: 10px; border: 1px dashed #9fbadb; border-radius: 7px; background: #f5f9fd; color: #2b6cb0; font-size: 12.5px; font-weight: 600; }
  .exc-mais small { color: #6b8bb0; font-weight: normal; }
  .exc-mais:hover { background: #e8f0fa; border-color: #2b6cb0; }

  .exc-foot { flex: 0 0 auto; display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 12px 20px; border-top: 1px solid #e6eaee; }
  .exc-foot-info { font-size: 12px; color: #6b747e; }
  .exc-sair { display: inline-flex; align-items: center; gap: 7px; background: #fdf1f1; border: 1px solid #e4d7d7; border-radius: 5px; padding: 8px 18px; font-size: 12.5px; color: #a13c3c; font-weight: 600; }
  .exc-sair:hover { background: #fbe6e6; }
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; }

  @media (max-width: 640px) {
    .exc-item { flex-wrap: wrap; }
    .exc-hora { display: none; }
    .exc-ver { width: 100%; justify-content: center; }
    .exc-head-resumo { display: none; }
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/ExtratosContaModal.vue